import xhr2 from 'xhr2'

const isJSDOM = () => (
  navigator.userAgent.includes('Node.js') ||
  navigator.userAgent.includes('jsdom')
)

export const XHR = isJSDOM() ? xhr2 : XMLHttpRequest
